import React from 'react';
import { Switch } from 'antd';
import withLabelAndMeta from './withLabelandMeta';

const Bool = ({
  field, // { name, value, onChange, onBlur }
  fieldDefinition,
  setFieldValue,
}) => (
  <Switch
    id={fieldDefinition.key}
    {...field}
    checked={field.value}
    size="small"
    onChange={value => setFieldValue(fieldDefinition.key, value)}
  />
);

export default withLabelAndMeta(Bool);
